import $ from 'cash-dom'
import Breakpoints from '../utils/breakpoints'
import Transitioner from '../utils/transitioner'

export default class Header {
  constructor({ $container } = {}) {
    this.$container = $container
    this.open = false

    this.constructElements()

    this.constructEvents()

    this.constructTransitioner()
  }

  static init() {
    const $containers = $(Header.selectors.container)

    if ($containers.length) {
      $containers.each((i, elem) => {
        const constructed = new Header({ $container: $(elem) })
      })
    }
  }

  constructElements() {
    this.$body = $('body')
    this.$window = $(window)
    this.$hamburger = this.$container.find(Header.selectors.hamburger)
    this.$main = this.$container.find(Header.selectors.main)
  }

  constructEvents() {
    this.$window
      .on('resize', (e) => this.handleResize({ e }))

    this.$container
      .on('click', Header.selectors.hamburger, (e) => this.handleHamburgerClick({ e }))
  }

  constructTransitioner() {
    this.transitioner = new Transitioner({
      $container: this.$main,
      displayValue: 'flex',
      hideMode: 'display',
      visibleClass: Header.classes.mainOpen,
    })
  }

  doClose() {
    this.open = false

    this.$body.css('overflow', '')

    this.$container.removeClass(Header.classes.open)

    this.transitioner.doHide()
  }

  doOpen() {
    this.open = true

    this.$body.css('overflow', 'hidden')

    this.$container.addClass(Header.classes.open)

    this.transitioner.doShow()
  }

  handleResize({ e }) {
    // nothing to do if we're already closed
    if (!this.open) {
      return
    }

    if (Breakpoints.has('lg')) {
      this.doClose()
    }
  }

  handleHamburgerClick({ e }) {
    if (this.open) {
      this.doClose()
    } else {
      this.doOpen()
    }
  }
}

Header.selectors = {
  container: '.js-header',
  hamburger: '.js-header-hamburger',
  main: '.js-header-main',
}

Header.classes = {
  open: 'c-header--open',
  mainOpen: 'c-header__main--open',
}
